module.exports = __webpack_public_path__ + "img/zip.8d18ce5c.svg";